export enum loginVia {
    TEACHERS = 'teachers',
    WATSON = 'watson',
    GLORIFIRE = 'glorifire'
}
const loginSources: string[] = Object.values(loginVia);

export default loginSources;